<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>Retenciones</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>Retenciones</h6>
    </table>


    <button style="background-color: transparent; color:#10384f;" mat-mini-fab aria-label="Salir" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
    <div class="container-fluid mt-4">

        <div class="row align-items-center">

            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="mat-table-pedidos">
                    <table mat-table matTableResponsive [dataSource]="dataSource" matSort #matSort="matSort"
                        matSortActive="tipoRetencion" matSortDirection="asc">
                        
                        <ng-container matColumnDef="aprobado">
                            <th mat-header-cell *matHeaderCellDef>{{Etiquetas.RetencionAprobada}}</th>
                            <td mat-cell *matCellDef="let r">
                                <button (click)="toggleSeleccionMotivo(r)">
                                    <mat-icon color="accent-darker">{{ motivosSeleccionados.has(r) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="tipoRetencion">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.TipoRetencion}}
                            </th>
                            <td mat-cell *matCellDef="let r">
                                {{r.tipoRetencion}} </td>
                            <td mat-footer-cell *matFooterCellDef> </td>
                        </ng-container>

                        <ng-container matColumnDef="mensajeRetencion">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.MensajeRetencion}}
                            </th>
                            <td mat-cell *matCellDef="let r">
                                {{r.mensajeRetencion}} </td>
                            <td mat-footer-cell *matFooterCellDef> </td>
                        </ng-container>


                        <!-- <ng-container matColumnDef="fechaAprobacion">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.FechaAprobacionRetencion}}
                            </th>
                            <td mat-cell *matCellDef="let r">
                                {{r.fechaAprobacion | date:'dd/MM/yyyy HH:mm'}} </td>
                            <td mat-footer-cell *matFooterCellDef> </td>
                        </ng-container>
                        <ng-container matColumnDef="aprobador">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.NombreApellidoAprobadorRetencion}}
                            </th>
                            <td mat-cell *matCellDef="let r">
                                {{r.aprobador}} </td>
                            <td mat-footer-cell *matFooterCellDef> </td>
                        </ng-container> -->

                        <!-- <ng-container matColumnDef="comentario">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.Comentario}}
                            </th>
                            <td mat-cell *matCellDef="let r">
                                {{r.comentario}} </td>
                            <td mat-footer-cell *matFooterCellDef> </td>
                        </ng-container> -->



                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let r; columns: displayedColumns;">
                        </tr>

                        <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                            <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                                {{Etiquetas.SinRegistros}}
                            </td>
                        </tr>
                    </table>

                    <mat-paginator #matPaginator="matPaginator" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
        <!-- <form [formGroup]="form">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.MotivoRetencion}}</mat-label>
                        <mat-select (selectionChange)='seleccionarMotivoRetencion($event.value)'  formControlName="idMotivoRetencion">
                            <mat-option [value]="">- Seleccione -</mat-option>
                            <mat-option *ngFor="let mr of motivosRetencion" [value]="mr.idItem">{{mr.descripcion}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Comentario}}</mat-label>

                        <textarea #comentario matInput maxlength="4000" formControlName="comentarioLogAutorizacion"
                            type="text"></textarea>
                        <mat-hint align="start">Máximo: 4000
                            caracteres</mat-hint>
                        <mat-hint align="end">{{comentario.value?.length
                            || 0}} / 4000</mat-hint>



                    </mat-form-field>
                </div>

            </div>
        </form> -->
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button (click)="aceptar()" mat-flat-button color="accent" [disabled]="!hayAprobado()">Aceptar</button>
</mat-dialog-actions>